import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  modal: {
    width: '100%',
    maxWidth: 500,
    padding: '32px 10px 32px 10px',
    backgroundColor: 'white',
    overflow: 'hidden',
    minHeight: 'min(536px, 75vh)',
  },
  contentContainer: {
    margin: '0 20px 0 20px',
  },
  greyBackground: {
    backgroundColor: '#f5f5f5',
  },
  indicatorTitle: {
    fontFamily: 'Merriweather',
    fontSize: 22,
    fontWeight: 900,
    margin: 'auto',
    padding: '30px 0 15px 0',
    textAlign: 'center',
  },
  indicatorRoot: {
    height: 102,
    backgroundColor: 'white',
    margin: '-32px -32px 0 -32px',
    padding: '0 32px 0 32px',
  },
  indicatorContainer: {
    background: 'transparent',
    transitionProperty: 'all, padding-right 0ms',
  },
  indicatorWrapper: {
    position: 'relative',
    margin: '0 auto',
    padding: '0 20px',
  },
  indicator: {
    display: 'flex',
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    flexBasis: 0,
    flexGrow: 1,
    borderBottom: `5px solid ${custom.grey[6]}`,
    '&:not(:last-child)': {
      marginRight: 4,
    },
  },
  stepActive: {
    borderColor: palette.primary.main,
  },
  animationContainer: {
    position: 'absolute',
  },
  stepTitle: {
    fontSize: 14,
    lineHeight: 1.4,
    margin: '0 0 5px 0',
    textAlign: 'center',
    color: custom.grey[10],
    width: '100%',
  },
  stepTitleActive: {
    color: palette.primary.main,
  },
}));
